import { SxProps, Theme } from '@mui/material';

export const paperStyles: SxProps<Theme> = {
  p: 3,
  mb: 3,
};

export const headerBoxStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2,
};

export const titleBoxStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const titleTypographyStyles: SxProps<Theme> = {
  fontWeight: "bold",
};

export const feedbackSubmittedContainerStyles = {
  display: "flex",
  alignItems: "center",
  gap: 1,
} as const;

export const feedbackSubmittedAlertStyles: SxProps<Theme> = {
  py: 0.5,
  px: 2,
};

export const editButtonStyles: SxProps<Theme> = {
  ml: 1,
};

export const successTooltipStyles: SxProps<Theme> = {
  backgroundColor: "#d4edda",
  border: "1px solid #c3e6cb",
  color: "#155724",
  padding: "12px 16px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  gap: 1,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  fontSize: "14px",
  fontWeight: 500,
  mb: 3,
};

export const successIconStyles: SxProps<Theme> = {
  width: 16,
  height: 16,
  borderRadius: "50%",
  backgroundColor: "#28a745",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "10px",
  color: "white",
};

export const ratingBoxStyles: SxProps<Theme> = {
  mb: 3,
};

export const ratingLabelStyles: SxProps<Theme> = {
  mb: 1,
};

export const ratingContainerStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 2,
};

export const getRatingStyles = (): SxProps<Theme> => ({
  "& .MuiRating-icon": {
    opacity: "1 !important",
    transition: "opacity 0.2s",
  },
  "& .MuiRating-iconFilled": {
    color: "#faaf00 !important",
  },
  "& .MuiRating-iconEmpty": {
    color: "rgba(0, 0, 0, 0.26) !important",
  },
  "&.Mui-disabled": {
    opacity: "0.8 !important",
  },
});

export const dividerStyles: SxProps<Theme> = {
  my: 2,
};

export const reasonsBoxStyles: SxProps<Theme> = {
  mb: 3,
};

export const getCheckboxStyles = (isEditing: boolean): SxProps<Theme> => ({
  opacity: !isEditing ? 0.6 : 1,
  transition: "opacity 0.2s",
});

export const checkboxLabelStyles: SxProps<Theme> = {
  "& .MuiFormControlLabel-label": {
    opacity: "1 !important",
    color: "rgba(0, 0, 0, 0.87) !important",
  },
  "& .MuiFormControlLabel-label.Mui-disabled": {
    opacity: "1 !important",
    color: "rgba(0, 0, 0, 0.87) !important",
  },
};

export const validationErrorStyles: SxProps<Theme> = {
  mt: 1,
};

export const additionalFeedbackBoxStyles: SxProps<Theme> = {
  mb: 3,
};

export const additionalFeedbackLabelStyles: SxProps<Theme> = {
  mb: 2,
};

export const getTextFieldStyles = (isEditing: boolean): SxProps<Theme> => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      opacity: !isEditing ? 0.6 : 1,
      transition: "opacity 0.2s",
    },
  },
  "& .MuiInputBase-input": {
    opacity: "1 !important",
    color: "rgba(0, 0, 0, 0.87) !important",
    WebkitTextFillColor: "rgba(0, 0, 0, 0.87) !important",
  },
  "& .MuiInputBase-input.Mui-disabled": {
    opacity: "1 !important",
    color: "rgba(0, 0, 0, 0.87) !important",
    WebkitTextFillColor: "rgba(0, 0, 0, 0.87) !important",
  },
  "& .MuiInputLabel-root": {
    opacity: "1 !important",
    color: "rgba(0, 0, 0, 0.6) !important",
  },
  "& .MuiInputLabel-root.Mui-disabled": {
    opacity: "1 !important",
    color: "rgba(0, 0, 0, 0.6) !important",
  },
  "& .MuiFormHelperText-root": {
    opacity: "1 !important",
    color: "rgba(0, 0, 0, 0.6) !important",
  },
});

export const actionButtonsBoxStyles: SxProps<Theme> = {
  display: "flex",
  gap: 2,
};

export const submitButtonStyles: SxProps<Theme> = {
  minWidth: "200px",
};